// extracted by mini-css-extract-plugin
module.exports = {"root":"ListInfoDetail_root_1uL7H","label":"ListInfoDetail_label_2qLMQ","value":"ListInfoDetail_value_iBa0d"};